export enum TypeDroitEnum {

    ACCES_APPLICATION,
    OBJETIHM_VISIBLE,
    OBJETIHM_MODIFIABLE
}
